import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = { templates: Object }

  filterTemplates(event) {
    const kind = event.target.value
    const templates = this.templatesValue[kind]
    if (templates == null) return

    const select = this.selectTarget
    const current = select.value

    select.innerHTML = ""
    templates.forEach(t => {
      const option = document.createElement("option")
      option.value = t
      option.textContent = t
      select.appendChild(option)
    })

    // Zachowaj aktualny wybór jeśli dostępny w nowej liście
    if (templates.includes(current)) {
      select.value = current
    } else {
      select.value = templates[0]
    }
  }
}
